import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
declare var $: any;

@Component({
    selector: "browse-files-button",
    templateUrl: "./browse-files-button.component.html",
    styleUrls: ["./browse-files-button.component.scss"],
    imports: [TranslocoPipe]
})
export class EffBrowseFilesButtonComponent {
    @Input() text: string;
    @Input() allowedFileExtensions: string;
    @Input() dataUiid: string = "undefined";
    @Output() onFilesDropped: EventEmitter<File[]> = new EventEmitter();

    @ViewChild("fileInput", { static: true }) fileInput: ElementRef;

    openFileSelect() {
        $(this.fileInput.nativeElement).trigger("click");
    }

    updateFiles() {
        this.onFilesDropped.emit(this.fileInput.nativeElement.files);
    }
}
